import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/service/api-service/api-service';

export interface Album {
  id_media_library: number;
  title: string;
  event_date: string;
  media_tags?: string | null;
  status: string;
  status_label?: string;
  video_link?: string | null;
  file_link: string | null;
}

export interface AlbumMedia {
  id: number;
  type: 'image' | 'video';
  file_id: number | null;
  file_link: string | null;
  file_name: string | null;
  video_link: string | null;
  media_order: number;
  is_main: boolean;
}

export interface AlbumDetail {
  id_media_library: number;
  title: string;
  event_date: string;
  media_tags?: string | null;
  status: string;
  status_label?: string;
  video_links: string[];
  media: AlbumMedia[];
}

@Injectable({ providedIn: 'root' })
export class MediatiqueService {
  constructor(private apiService: ApiService) {}

  getAlbums(page = 1, limit = 8, search = '', status = ''): Observable<any> {
    return this.apiService.post('/api/communication/mediatique/list', {
      page, limit,
      search: search || null,
      status: status || null,
    });
  }

  getAlbumById(id: number): Observable<any> {
    return this.apiService.get(`/api/communication/mediatique/${id}`);
  }

  createAlbum(formData: FormData): Observable<any> {
    return this.apiService.post('/api/communication/mediatique', formData);
  }

  updateAlbum(id: number, body: { title: string; event_date: string; media_tags?: string | null }): Observable<any> {
    return this.apiService.put(`/api/communication/mediatique/${id}`, body);
  }

  addVideoLinks(albumId: number, videoLinks: string[]): Observable<any> {
    return this.apiService.post(`/api/communication/mediatique/${albumId}/videos`, { video_links: videoLinks });
  }

  setStatus(id: number, status: 'ACTI' | 'INAC' | 'ARCH'): Observable<any> {
    return this.apiService.patch(`/api/communication/mediatique/${id}/status`, { status });
  }

  setMainMedia(albumId: number, mediaId: number): Observable<any> {
    return this.apiService.patch(`/api/communication/mediatique/${albumId}/main-media/${mediaId}`, {});
  }

  addPhotos(albumId: number, formData: FormData): Observable<any> {
    return this.apiService.post(`/api/communication/mediatique/${albumId}/photos`, formData);
  }

  deleteMedia(albumId: number, mediaId: number): Observable<any> {
    return this.apiService.delete(`/api/communication/mediatique/${albumId}/media/${mediaId}`);
  }

  reorderMedia(albumId: number, mediaIds: number[]): Observable<any> {
    return this.apiService.patch(`/api/communication/mediatique/${albumId}/reorder`, { media_ids: mediaIds });
  }

  deleteAlbum(id: number): Observable<any> {
    return this.apiService.delete(`/api/communication/mediatique/${id}`);
  }
}
